'use client';

import { c as _c } from "react/compiler-runtime";
import style from './GalleryFilterCategories.module.scss';
export const GalleryFilterCategories = props => {
  const $ = _c(21);
  const {
    queue,
    setQueue,
    groupCategories,
    activeSwitch,
    setActiveSwitch
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className={style.selector__title}>Очередь</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== groupCategories) {
    t1 = Object.keys(groupCategories);
    $[1] = groupCategories;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== activeSwitch || $[4] !== groupCategories || $[5] !== queue || $[6] !== setActiveSwitch || $[7] !== setQueue || $[8] !== t1) {
    t2 = <div className={style.selector__group}>{t0}{t1.map(q => <label key={q} className={style.selector__switch}><input value={q} className={style.radioButton} type="radio" name={queue} checked={queue === q} onChange={e => {
          setQueue(e.target.value);
          if (!groupCategories[e.target.value].includes(activeSwitch)) {
            setActiveSwitch(groupCategories[e.target.value][0]);
          }
        }} />{q}</label>)}</div>;
    $[3] = activeSwitch;
    $[4] = groupCategories;
    $[5] = queue;
    $[6] = setActiveSwitch;
    $[7] = setQueue;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className={style.selector__title}>Пространство</p>;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== activeSwitch || $[12] !== groupCategories || $[13] !== queue || $[14] !== setActiveSwitch) {
    t4 = groupCategories[queue]?.map((title, index) => {
      const uniqueKey = `${title.charAt(0)}-${index}`;
      return <label key={uniqueKey} className={style.selector__switch}><input value={title} className={style.radioButton} type="radio" name={title} checked={activeSwitch === title} onChange={e_0 => setActiveSwitch(e_0.target.value)} />{title}</label>;
    });
    $[11] = activeSwitch;
    $[12] = groupCategories;
    $[13] = queue;
    $[14] = setActiveSwitch;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t4) {
    t5 = <div className={style.selector__group}>{t3}{t4}</div>;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t2 || $[19] !== t5) {
    t6 = <div className={style.selector__box}>{t2}{t5}</div>;
    $[18] = t2;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};